import userflow from 'userflow.js';
import configData from '../../config/loader';

// SECURITY: Safely parse localStorage with error handling
let accountData = null;
try {
  const stored = localStorage.getItem('accountData');
  if (stored) {
    accountData = JSON.parse(stored);
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('Failed to parse accountData from localStorage');
}

function getToken() {
  return configData.userFlowToken;
}

export function userFlowInit() {
  const userFlowToken = getToken();
  if (userFlowToken !== null) {
    userflow.init(userFlowToken);
    // Guard the nested .data too: localStorage.accountData can exist with
    // data===null on a stale/partial session, which made accountData.data.email
    // throw "Cannot read properties of null (reading 'email')" at startup.
    if (accountData && accountData.data) {
      const newData = {
        name: `${accountData.data.firstName} ${accountData.data.lastName}`,
        email: accountData.data.email,
        signed_up_at: null,
      };
      // _.forIn(accountData.data, (value, key) => {
      //   if (key === 'id') return true;
      //   // Handle boolean strings for Userflow (expects numbers)
      //   if (value === 'false' || value === false) {
      //     newData[key] = 0;
      //     return true;
      //   }
      //   if (value === 'true' || value === true) {
      //     newData[key] = 1;
      //     return true;
      //   }
      //   const tempValue = _.parseInt(value);
      //   newData[key] = _.isNaN(tempValue) ? value : tempValue;
      // });

      const { id } = accountData.data;

      userflow.identify(id, newData);
    }
  }
}

export function userFlowTrackEvent(eventName, data = {}) {
  if (userflow.isIdentified()) {
    userflow.track(eventName, data);
  }
}

export function userFlowReset() {
  userflow.reset();
}

export function userFlowStartFlow(flowId) {
  if (userflow.isIdentified()) {
    userflow.start(flowId);
  }
}

export function userFlowUpdateAttribute(attribute, value) {
  if (userflow.isIdentified()) {
    const obj = {};
    obj[attribute] = value;
    userflow.updateUser(obj);
  }
}
